import { useContext } from 'react';

import { SelectedStudy } from '../contexts';

// ----------------------------------------------------------------------

const useSelectedStudy = () => {
  const context = useContext(SelectedStudy);

  if (!context) throw new Error('Selected study context must be use inside SelectedStudyProvider');

  return context;
};

export default useSelectedStudy;
